var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInquiryImg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 12C16 11.4477 16.4477 11 17 11H95C95.5523 11 96 11.4477 96 12V108C96 108.552 95.5523 109 95 109H17C16.4477 109 16 108.552 16 108V12Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.5 12C96.5 11.1716 95.8284 10.5 95 10.5H17C16.1716 10.5 15.5 11.1716 15.5 12V108C15.5 108.828 16.1716 109.5 17 109.5H95C95.8284 109.5 96.5 108.828 96.5 108V12ZM95 11.5C95.2761 11.5 95.5 11.7239 95.5 12V108C95.5 108.276 95.2761 108.5 95 108.5H17C16.7239 108.5 16.5 108.276 16.5 108V12C16.5 11.7239 16.7239 11.5 17 11.5H95Z",
    fill: "#555555"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74 51.5C74 61.165 66.165 69 56.5 69C46.835 69 39 61.165 39 51.5C39 41.835 46.835 34 56.5 34C66.165 34 74 41.835 74 51.5Z",
    fill: "#F5F5F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.5 68C65.6127 68 73 60.6127 73 51.5C73 42.3873 65.6127 35 56.5 35C47.3873 35 40 42.3873 40 51.5C40 60.6127 47.3873 68 56.5 68ZM56.5 69C66.165 69 74 61.165 74 51.5C74 41.835 66.165 34 56.5 34C46.835 34 39 41.835 39 51.5C39 61.165 46.835 69 56.5 69Z",
    fill: "#555555"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49 48C49.5523 48 50 48.4477 50 49V53H48V49C48 48.4477 48.4477 48 49 48Z",
    fill: "#555555"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63 48C63.5523 48 64 48.4477 64 49V53H62V49C62 48.4477 62.4477 48 63 48Z",
    fill: "#555555"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.4345 57.7525C61.5712 57.9924 61.4876 58.2977 61.2477 58.4345L60.8557 58.6579C57.6975 60.458 53.8036 60.3675 50.7325 58.4225C50.4992 58.2747 50.4299 57.9659 50.5777 57.7326C50.7254 57.4993 51.0343 57.4299 51.2676 57.5777C54.0261 59.3247 57.5238 59.4061 60.3605 57.7891L60.7525 57.5657C60.9924 57.429 61.2977 57.5126 61.4345 57.7525Z",
    fill: "#555555"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.5 29.5C44.3827 29.5 34.5 40.0608 34.5 53.1647C34.5 61.8731 38.8712 69.47 45.3632 73.5775L44.8286 74.4225C38.0402 70.1275 33.5 62.208 33.5 53.1647C33.5 39.577 43.7644 28.5 56.5 28.5C69.2356 28.5 79.5 39.577 79.5 53.1647H78.5C78.5 40.0608 68.6172 29.5 56.5 29.5Z",
    fill: "#555555"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29 50.8333C29 47.6117 31.6117 45 34.8333 45C35.4777 45 36 45.5223 36 46.1667V56.8333C36 57.4777 35.4777 58 34.8333 58C31.6117 58 29 55.3883 29 52.1667V50.8333Z",
    fill: "#4267EB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 56.8333V46.1667C35 46.0746 34.9254 46 34.8333 46C32.164 46 30 48.164 30 50.8333V52.1667C30 54.836 32.164 57 34.8333 57C34.9254 57 35 56.9254 35 56.8333ZM34.8333 45C31.6117 45 29 47.6117 29 50.8333V52.1667C29 55.3883 31.6117 58 34.8333 58C35.4777 58 36 57.4777 36 56.8333V46.1667C36 45.5223 35.4777 45 34.8333 45Z",
    fill: "#555555"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M77 46.1667C77 45.5223 77.5223 45 78.1667 45C81.3883 45 84 47.6117 84 50.8333V52.1667C84 55.3883 81.3883 58 78.1667 58C77.5223 58 77 57.4777 77 56.8333V46.1667Z",
    fill: "#4267EB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83 52.1667V50.8333C83 48.164 80.836 46 78.1667 46C78.0746 46 78 46.0746 78 46.1667V56.8333C78 56.9254 78.0746 57 78.1667 57C80.836 57 83 54.836 83 52.1667ZM78.1667 45C77.5223 45 77 45.5223 77 46.1667V56.8333C77 57.4777 77.5223 58 78.1667 58C81.3883 58 84 55.3883 84 52.1667V50.8333C84 47.6117 81.3883 45 78.1667 45Z",
    fill: "#555555"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47 71.5C47 73.433 45.433 75 43.5 75C41.567 75 40 73.433 40 71.5C40 69.567 41.567 68 43.5 68C45.433 68 47 69.567 47 71.5Z",
    fill: "#4267EB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5 74C44.8807 74 46 72.8807 46 71.5C46 70.1193 44.8807 69 43.5 69C42.1193 69 41 70.1193 41 71.5C41 72.8807 42.1193 74 43.5 74ZM43.5 75C45.433 75 47 73.433 47 71.5C47 69.567 45.433 68 43.5 68C41.567 68 40 69.567 40 71.5C40 73.433 41.567 75 43.5 75Z",
    fill: "#555555"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 86.5C28 86.2239 28.2472 86 28.5521 86H80.4479C80.7528 86 81 86.2239 81 86.5C81 86.7761 80.7528 87 80.4479 87H28.5521C28.2472 87 28 86.7761 28 86.5Z",
    fill: "#D1DDFB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 93.5C28 93.2239 28.2477 93 28.5532 93H72.4468C72.7523 93 73 93.2239 73 93.5C73 93.7761 72.7523 94 72.4468 94H28.5532C28.2477 94 28 93.7761 28 93.5Z",
    fill: "#D1DDFB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5488 55.9648L109.393 66.809L85.3809 90.8211L74.5368 79.9769L98.5488 55.9648Z",
    fill: "#D1DDFB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.1953 55.6114H98.9024L109.747 66.4555V67.1626L85.7345 91.1747H85.0274L74.1832 80.3305V79.6234L98.1953 55.6114ZM98.5488 56.672L75.2439 79.977L85.3809 90.114L108.686 66.8091L98.5488 56.672Z",
    fill: "#555555"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M100.034 54.4768C101.206 53.3052 103.105 53.3052 104.277 54.4768L110.878 61.0783C112.05 62.2499 112.05 64.1494 110.878 65.3209L109.392 66.8069L98.548 55.9627L100.034 54.4768Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.6804 54.1233C101.047 52.7565 103.263 52.7565 104.63 54.1233L111.232 60.7248C112.598 62.0917 112.598 64.3077 111.232 65.6746L109.746 67.1605H109.039L98.1945 56.3163V55.6092L99.6804 54.1233ZM103.923 54.8304C102.947 53.8541 101.364 53.8541 100.388 54.8304L99.2551 55.9628L109.392 66.0998L110.525 64.9675C111.501 63.9912 111.501 62.4082 110.525 61.4319L103.923 54.8304Z",
    fill: "#555555"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2124 90.0461L74.5361 79.9766L85.3803 90.8207L75.3107 93.1445L72.2124 90.0461Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.3983 79.496C74.573 79.4459 74.7612 79.4946 74.8897 79.6231L85.7338 90.4672C85.8624 90.5958 85.911 90.7839 85.8609 90.9586C85.8108 91.1334 85.6698 91.2671 85.4927 91.308L75.4231 93.6317C75.2552 93.6705 75.0791 93.62 74.9572 93.4981L71.8588 90.3998C71.7369 90.2779 71.6864 90.1018 71.7252 89.9338L74.0489 79.8642C74.0898 79.6871 74.2236 79.5461 74.3983 79.496ZM74.8205 80.9681L72.7619 89.8886L75.4683 92.595L84.3888 90.5365L74.8205 80.9681Z",
    fill: "#555555"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2129 90.0469L75.3112 93.1452L72.5611 94.0619C71.7793 94.3225 71.0356 93.5788 71.2962 92.797L72.2129 90.0469Z",
    fill: "#555555"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9951 89.1211L76.2376 93.3635L72.7199 94.5361C71.5473 94.927 70.4317 93.8114 70.8226 92.6387L71.9951 89.1211ZM72.4321 90.9723L71.7713 92.955C71.641 93.3458 72.0128 93.7177 72.4037 93.5874L74.3863 92.9265L72.4321 90.9723Z",
    fill: "#555555"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInquiryImg1);
export default __webpack_public_path__ + "static/media/inquiry_img1.1ce5c28198b5c3a711457be4f1834336.svg";
export { ForwardRef as ReactComponent };